import React from 'react';
import DatePicker from '../elements/datePicker/DatePicker';
import { Container, Row, Col, Card, CardHeader, Button } from 'reactstrap';
import { AccountSettingsIcon } from '../elements/icons/Icons';

const AccountDetails = ({ dto, onTextInputChange, onBirthdayChange, onSubmit, displayBody }) => {
    return (
        <Card className="account-details-wrapper">
            <CardHeader className="d-flex justify-content-between">
                <h6 className="m-0 font-weight-bold">
                    <AccountSettingsIcon />
                    Profile
                </h6>
                <Button color="primary" onClick={onSubmit}>
                    {displayBody ? 'Edit' : 'Save'}
                </Button>
            </CardHeader>
            <Container className="my-3" fluid>
                <Row>
                    <Col xs={12} md={3}>
                        <div className="form-group">
                            <label>First name</label>
                            <input
                                type="text"
                                name="firstName"
                                className="form-control"
                                placeholder="First name"
                                value={dto.firstName ? dto.firstName : ''}
                                onChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="form-group">
                            <label>Second name</label>
                            <input
                                type="text"
                                name="lastName"
                                className="form-control"
                                placeholder="Second name"
                                value={dto.lastName ? dto.lastName : ''}
                                onChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="text"
                                name="email"
                                className="form-control"
                                placeholder="Email"
                                value={dto.email ? dto.email : ''}
                                onChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={3}>
                        <div className="form-group">
                            <label>Industry</label>
                            <input
                                type="text"
                                name="category"
                                className="form-control"
                                placeholder="Industry"
                                value={dto.category ? dto.category : ''}
                                onChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="form-group">
                            <label>Professional title</label>
                            <input
                                type="text"
                                name="position"
                                className="form-control"
                                placeholder="Professional title"
                                value={dto.position ? dto.position : ''}
                                onChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="form-group">
                            <label>Personal/company website</label>
                            <input
                                type="text"
                                name="websiteLink"
                                className="form-control"
                                placeholder="website"
                                value={dto.websiteLink ? dto.websiteLink : ''}
                                onChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="form-group">
                            <DatePicker
                                setDate={onBirthdayChange}
                                date={dto.birthdayTimestamp ? dto.birthdayTimestamp.toDate() : null}
                                label="Age (DOB)"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </Card>
    );
};

export default AccountDetails;
